// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CustomerProfileTextModuleScss from "../../styles/CustomerProfileText.module.scss";

var styles = CustomerProfileTextModuleScss;

function CustomerProfileTextCmp(Props) {
  var heading = Props.heading;
  var subheading = Props.subheading;
  return React.createElement("div", {
              className: styles["text-wrapper"]
            }, React.createElement("p", {
                  className: styles.heading
                }, heading), React.createElement("p", {
                  className: styles.subheading
                }, subheading));
}

var make = CustomerProfileTextCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
